'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	class: {
		type: 'string'
	},
	onClick: {
		type: 'function'
	},
	onMouseOut: {
		type: 'function'
	},
	onMouseOver: {
		type: 'function'
	}
}; /** @jsx dom */


var defaultProps = {
	component: 'div'
};

function render(_ref) {
	var props = _ref.props;
	var children = props.children,
	    component = props.component,
	    onClick = props.onClick,
	    onMouseOut = props.onMouseOut,
	    onMouseOver = props.onMouseOver,
	    styleClasses = props.styleClasses;


	return (0, _magicVirtualElement2.default)(component, {
		class: ['Dropdown', props.class, styleClasses && styleClasses.Dropdown],
		'data-style-attr': 'Dropdown',
		onClick: onClick,
		onMouseOut: onMouseOut,
		onMouseOver: onMouseOver
	}, children);
}

exports.default = { defaultProps: defaultProps, propTypes: propTypes, render: render };